import { useState } from "react";

// Simple one-question wizard: Internal → through-jamb, External → tabs on inside
export default function FixingHelper({ currentApplication, onApply, onClose }) {
  const [answer, setAnswer] = useState(currentApplication || "");

  const rec = answer === "Internal"
    ? {
        value: "Pre-drilled holes through jamb centre",
        label: "Through-Jamb Fixings",
        reason:
          "For internal doors we almost always use pre-drilled fixings through the jamb centre — clean, invisible from the leaf, and the strongest attachment into stud framing.",
      }
    : answer === "External"
    ? {
        value: "Tabs on inside",
        label: "Tabs Around Inside",
        reason:
          "For external doors we usually run steel tabs welded around the inside face of the frame, sitting behind the finished lining — hidden, weather-tight, and simple to install into an opening.",
      }
    : null;

  return (
    <div
      data-testid="fixing-helper-panel"
      className="mt-3 rounded-sm border border-[#c6a87c]/40 bg-white p-5"
    >
      <div className="flex items-center justify-between border-b border-[#c6a87c]/25 pb-3">
        <p className="font-tech text-[10px] uppercase tracking-[0.28em] text-[#c6a87c]">
          Fixing Recommender
        </p>
        <button
          type="button"
          onClick={onClose}
          data-testid="fixing-helper-close"
          className="font-tech text-[10px] uppercase tracking-[0.24em] text-[#0a0a0c]/40 hover:text-[#0a0a0c]"
        >
          Close ×
        </button>
      </div>

      <div className="mt-5">
        <p className="font-serif-display text-lg leading-snug text-[#0a0a0c]">
          Is this door internal or external?
        </p>
        <div className="mt-4 grid grid-cols-2 gap-2">
          {["Internal", "External"].map((opt) => {
            const chosen = answer === opt;
            return (
              <button
                key={opt}
                type="button"
                data-testid={`fixing-helper-${opt.toLowerCase()}`}
                onClick={() => setAnswer(opt)}
                className={`rounded-sm border px-3 py-2.5 font-tech text-[10px] font-semibold uppercase tracking-[0.18em] transition-all duration-300 ${
                  chosen
                    ? "border-[#c6a87c] bg-[#c6a87c]/10 text-[#0a0a0c]"
                    : "border-[#0a0a0c]/15 text-[#0a0a0c]/75 hover:border-[#c6a87c] hover:text-[#0a0a0c]"
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>

      {rec && (
        <div className="mt-6 border-t border-[#c6a87c]/20 pt-5" data-testid="fixing-helper-recommendation">
          <p className="font-tech text-[10px] uppercase tracking-[0.28em] text-[#c6a87c]">
            Recommended fixing
          </p>
          <p className="mt-3 font-serif-display text-xl leading-tight text-[#0a0a0c]">
            {rec.label}
          </p>
          <p className="mt-3 font-body text-[13px] leading-[1.7] text-[#0a0a0c]/70">
            {rec.reason}
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => onApply(rec.value)}
              data-testid="fixing-helper-apply"
              className="rounded-full bg-[#c6a87c] px-5 py-2.5 font-tech text-[10px] uppercase tracking-[0.24em] text-[#0a0a0c] transition-colors hover:bg-[#d8bd93]"
            >
              Apply {rec.label}
            </button>
          </div>
          <p className="mt-3 font-body text-[11px] leading-relaxed text-[#0a0a0c]/50">
            Tip: on-site conditions may require face-fixed or hybrid fixings. Note anything unusual in "Additional notes".
          </p>
        </div>
      )}
    </div>
  );
}
